import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export const SR_STATIC_FOOTER_THEME_BUYER_AGENT_FORM_PAGE =
  'SR_STATIC_FOOTER_THEME_BUYER_AGENT_FORM_PAGE';
const SR_STATIC_FOOTER_THEME_TO_CLASSNAME_MAPPING = {
  [SR_STATIC_FOOTER_THEME_BUYER_AGENT_FORM_PAGE]: 'buyerAgentFormPage',
};

const SR_STATIC_FOOTER_SIZE_TO_CLASSNAME_MAPPING = {
  135: 'size-135',
  '135-105': 'size-135 size-105',
};

const SrStaticFooter = ({ children, size, theme }) => {
  return (
    <div
      className={classnames(
        'SrStaticFooter',
        SR_STATIC_FOOTER_SIZE_TO_CLASSNAME_MAPPING[size],
        SR_STATIC_FOOTER_THEME_TO_CLASSNAME_MAPPING[theme],
      )}
    >
      {children}
    </div>
  );
};

SrStaticFooter.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOf(Object.keys(SR_STATIC_FOOTER_SIZE_TO_CLASSNAME_MAPPING)),
  theme: PropTypes.oneOf(Object.keys(SR_STATIC_FOOTER_THEME_TO_CLASSNAME_MAPPING)),
};

SrStaticFooter.displayName = 'SrStaticFooter';

export default SrStaticFooter;
